export enum CalendarRange {
  DAY = 'CALENDAR_RANGE/DAY',
  WEEK = 'CALENDAR_RANGE/WEEK',
  MONTH = 'CALENDAR_RANGE/MONTH',
  LISTWEEK = 'CALENDAR_RANGE/LISTWEEK'
}

export function getCalendarRangeByString(
  value: string
): CalendarRange | undefined {
  return (Object.values(CalendarRange) as string[]).includes(value)
    ? (value as CalendarRange)
    : undefined
}
